<template>
  <div class="table-op-col-bdr" style="background:#f1f1f1">
    <div class="content_box clearfix" style="margin-bottom:15px">
      <el-form :inline="true" size="mini" :model="formInline" class="demo-form-inline">
        <el-form-item label="竞价规则名称">
          <el-input v-model="formInline.name" placeholder="请输入竞价规则名称"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" placeholder="请选择状态">
            <el-option label="全部" value="all"></el-option>
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float:right">
          <el-button v-if="permissions.biddingRulesLook" v-track="{ action: 'ruleManage_query' }" type="primary" size="mini" @click="onSubmit">查询</el-button>
          <el-button plain @click="resetQuery" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_box content_box">
      <div class="clearfix" style="margin-bottom:15px">
        <span style="float:left;font-weight: 700;">规则列表</span>
        <el-button v-if="permissions.biddingRules" v-track="{ action: 'ruleManage_newRule' }" size="mini" type="danger"  @click="addOne" style="float:right">+&nbsp;新增规则</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="ruleId" label="规则ID"></el-table-column>
        <el-table-column prop="ruleName" label="规则名称"></el-table-column>
        <el-table-column prop="province" label="规则生效时间" width="250">
          <template slot-scope="scope">
            <div>{{scope.row.effectStartTm | timeFilter}}</div>
            <div>{{scope.row.effectEndTm | timeFilter}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="opUser" label="操作人" width="120"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">{{scope.row.status == 1?"启用":"禁用"}}</template>
        </el-table-column>
        <el-table-column label="操作时间" width="200">
          <template slot-scope="scope">{{scope.row.updateTm | timeFilter}}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
               v-track="{ action: 'ruleManage_disable' }"
              type="text"
              size="small"
              @click="disableItem(scope.row)"
              v-if="(scope.row.status ==1) && permissions.biddingRulesUnable"
            >禁用</el-button>
            <el-button
              v-track="{ action: 'ruleManage_able' }"
              type="text"
              size="small"
              @click="enableItem(scope.row)"
              v-if="scope.row.status ==2"
            >启用</el-button>
            <el-button v-if="permissions.biddingRulesUpdate" v-track="{ action: 'ruleManage_alter' }" type="text" size="small" @click="modifyItem(scope.row)">修改</el-button>
            <el-button v-if="permissions.biddingRulesDelete" v-track="{ action: 'ruleManage_delete' }" type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
            <el-button v-if="permissions.biddingRulesQuery" v-track="{ action: 'ruleManage_check' }" @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="60%">
      <el-form :model="addform" :inline="true" :rules="rules" ref="addform">
        <el-form-item label="规则名称" :label-width="formLabelWidth" prop="name">
          <el-input
            v-model="addform.name"
            placeholder="请输入竞价规则名称"
            maxlength="30"
            v-show="flag == 1 || flag ==3"
          ></el-input>
          <span v-show="flag == 2">{{detailObj.ruleName}}</span>
        </el-form-item>
        <div style="margin-top:15px">
          <div style="display:inline-block;margin-bottom:27px">
            <el-form-item label="规则生效开始时间" :label-width="formLabelWidth" prop="startTm">
              <el-date-picker
                v-model="addform.startTm"
                v-show="flag == 1 || flag ==3"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择开始日期时间"
              ></el-date-picker>
              <span v-show="flag == 2">{{detailObj.effectStartTm}}</span>
            </el-form-item>
          </div>
          <div style="display:inline-block;margin-bottom:27px">
              <el-form-item label="规则生效结束时间" :label-width="formLabelWidth" prop="endTm">
                <el-date-picker
                  v-model="addform.endTm"
                  v-show="flag == 1 || flag ==3"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择结束日期时间"
                ></el-date-picker>
                <span v-show="flag == 2">{{detailObj.effectEndTm}}</span>
              </el-form-item>
          </div>
        </div>
        <!-- <div style="margin:15px 0;font-size:18px">定标设置</div> -->
        <div style="margin-top:15px">
          <el-form-item label="期望价倍数" :label-width="formLabelWidth" prop="minmultiple">
            <el-input-number
              v-show="flag == 1 || flag ==3"
              v-model="addform.minmultiple"
              controls-position="right"
              :precision="1"
              :step="0.1"
              :min="0"
            ></el-input-number>
            <span v-show="flag == 2">{{detailObj.expPriceMultiples}}</span>
          </el-form-item>
          <span style="margin-right:15px;line-height:40px;">-</span>
          <el-form-item prop="maxmultiple">
            <el-input-number
              v-show="flag == 1 || flag ==3"
              v-model="addform.maxmultiple"
              controls-position="right"
              :precision="1"
              :step="0.1"
              :min="0"
              :max="9.9"
            ></el-input-number>
            <span v-show="flag == 2">{{detailObj.expPriceMultiplesEnd}}</span>
          </el-form-item>
        </div>
        <div style="margin-top:15px">
          <el-form-item label="报价区间（元）" :label-width="formLabelWidth" prop="minprice">
            <!-- <span style="margin-left:20px;margin-right:10px">最低价</span> -->
            <el-input-number
              v-show="flag == 1 || flag ==3"
              v-model="addform.minprice"
              controls-position="right"
            ></el-input-number>
            <span v-show="flag == 2">{{detailObj.minPrice}}</span>
          </el-form-item>
          <span style="margin-right:15px;line-height:40px;">-</span>
          <el-form-item prop="maxprice">
            <!-- <span style="margin-right:10px">最高价</span> -->
            <el-input-number
              v-show="flag == 1 || flag ==3"
              v-model="addform.maxprice"
              controls-position="right"
              :max="100000"
            ></el-input-number>
            <span v-show="flag == 2">{{detailObj.maxPrice}}</span>
          </el-form-item>
        </div>
        <div style="padding-left:20px;color:#ababab;margin-top:22px">下单时设置期望价才启用此规则定标入围范围，期望价倍数最低0.1倍，最高9.9倍</div>
        <div style="margin-top:15px">
          <el-form-item label="自动评标" :label-width="formLabelWidth">
            <el-radio-group v-model="radioVal">
              <el-radio label="1">最低价模式</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogFormVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="save('addform')" v-show="flag == 1 || flag ==3">保 存</el-button>
      </div>
    </el-dialog>
     <el-dialog title="竞价规则" :visible.sync="dialogViewVisible" width="60%">
      <el-form  :inline="true">
        <el-form-item label="规则名称" :label-width="formLabelWidth">
          <span v-show="flag == 2">{{detailObj.ruleName}}</span>
        </el-form-item>
        <div>
          <div style="display:inline-block;margin-bottom:10px">
            <el-form-item label="规则生效开始时间" :label-width="formLabelWidth">
              <span>{{detailObj.effectStartTm}}</span>
            </el-form-item>
          </div>
          <div style="display:inline-block;margin-bottom:10px">
              <el-form-item label="规则生效结束时间" :label-width="formLabelWidth">
                <span>{{detailObj.effectEndTm}}</span>
              </el-form-item>
          </div>
        </div>
        <!-- <div style="margin:15px 0;font-size:18px">定标设置</div> -->
        <div>
          <el-form-item label="期望价倍数" :label-width="formLabelWidth">
            <span>{{detailObj.expPriceMultiples}}</span>
          </el-form-item>
          <span style="margin-right:15px;line-height:40px;">-</span>
          <el-form-item>
            <span>{{detailObj.expPriceMultiplesEnd}}</span>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="报价区间（元）" :label-width="formLabelWidth">
            <span>{{detailObj.minPrice}}</span>
          </el-form-item>
          <span style="margin-right:15px;line-height:40px;">-</span>
          <el-form-item>
            <span>{{detailObj.maxPrice}}</span>
          </el-form-item>
        </div>
        <div style="padding-left:20px;color:#ababab;margin-top:12px">下单时设置期望价才启用此规则定标入围范围，期望价倍数最低0.1倍，最高9.9倍</div>
        <div style="margin-top:15px">
          <el-form-item label="自动评标" :label-width="formLabelWidth">
            <el-radio-group v-model="radioVal">
              <el-radio label="1">最低价模式</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import fetchPost from "@/api/http.js";
export default {
  data() {
    var checkStartTm = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("开始时间不能为空"));
      } else {
        var time1 = new Date(value).getTime();
        var time3 = new Date().getTime();
        if ((time1 - time3) < 60000*5) {
            return callback(
              new Error("开始时间必须大于当前时间5分钟以上，请重新输入")
            );
          } else {
            if (this.addform.endTm) {
              var time2 = new Date(this.addform.endTm);
              if (time1 >= time2) {
                return callback(
                  new Error("开始时间不能晚于结束时间，请重新输入")
                );
              } else {
                callback();
              }
            }else{
               callback();
            }
          }
      }
    };
    var checkEndTm = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("结束时间不能为空，请重新输入"));
      } else {
        if (this.addform.startTm) {
          var time1 = new Date(value);
          var time2 = new Date(this.addform.startTm);
          if (time1 - time2 < 60000) {
            return callback(
              new Error(
                "结束时间必须大于开始时间1分钟，请重新输入"
              )
            );
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    var checkMinmultiple = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入最低倍数"));
      } else {
        if (this.addform.maxmultiple) {
          if (value > this.addform.maxmultiple) {
            return callback(new Error("最低倍数不得大于最高倍数，请重新输入"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    var checkMaxmultiple = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入最高倍数"));
      } else {
        if (this.addform.minmultiple) {
          if (value < this.addform.minmultiple) {
            return callback(new Error("最高倍数不得小于最低倍数，请重新输入"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    var checkMinprice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入最低价"));
      } else {
        if (this.addform.maxprice) {
          if (value > this.addform.maxprice) {
            return callback(new Error("最低价不得大于最高价，请重新输入"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    var checkMaxprice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入最高价"));
      } else {
        if (this.addform.minprice) {
          if (value < this.addform.minprice) {
            return callback(new Error("最高价不得小于最低价，请重新输入"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    return {
      permissions: {
				biddingRules: false,          //新增规则
        biddingRulesUnable: false,    //禁用
        biddingRulesUpdate: false,    //修改
        biddingRulesDelete: false,    //删除
        biddingRulesQuery: false,     //查看
        biddingRulesLook: false       //查询
			},
      msg: "111",
      currentPage: 1,
      total: 0,
      title: "新增竞价规则",
      formLabelWidth: "130px",
      dialogFormVisible: false,
      dialogViewVisible:false,
      flag: 1,
      radioVal:"1",
      formInline: {
        name: "",
        status: "all"
      },
      addform: {
        name: "",
        startTm: "",
        endTm: "",
        minmultiple: "",
        maxmultiple: "",
        minprice: "",
        maxprice: "",
        ruleId: "",
        status: "",
        autoEvalBidding: "",
      },
      detailObj: {},
      rules: {
        name: [
          { required: true, message: "请输入规则名称", trigger: "blur" },
          { max: 30, message: "长度不得大于30个字符", trigger: "blur" }
        ],
        startTm: [
          { required: true, validator: checkStartTm, trigger: "change" }
        ],
        endTm: [{ required: true, validator: checkEndTm, trigger: "change" }],
        minmultiple: [
          { required: true, validator:checkMinmultiple, trigger: "change" }
        ],
        maxmultiple: [
          { required: true, validator:checkMaxmultiple, trigger: "change" }
        ],
        minprice: [
          { required: true, validator: checkMinprice, trigger: "change" }
        ],
        maxprice: [
          { required: true, validator: checkMaxprice, trigger: "change" }
        ]
      },
      tableData: []
    };
  },
  filters: {
    timeFilter(val) {
      if (val) {
        var v = formatDate(new Date(val), "yyyy-MM-dd HH:mm:ss");
        return v;
      }
    }
  },
  created() {
    this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
  },
  mounted() {
    this.onSubmit();
  },
  methods: {
    resetQuery(){
      this.currentPage = 1;
      this.formInline.status = "all";
      this.formInline.name = "";
       this.queryBiddingRulesPage();
    },
    onSubmit() {
      this.currentPage = 1;
      this.queryBiddingRulesPage();
    },
    queryBiddingRulesPage() {
      var status;
      if (this.formInline.status == "all") {
        status = "";
      } else {
        status = this.formInline.status;
      }
      var data = {
        page: this.currentPage,
        pageSize: 10,
        ruleName: this.formInline.name,
        status: status
      };
      fetchPost("/saas/priceVieRules/queryPriceVieRulesPage", data).then(
        res => {
          if (res) {
            this.total = res.total;
            this.tableData = res.datas;
          } else {
            this.total = 0;
            this.tableData = [];
          }
        }
      );
    },
    addOne() {
      this.flag = 1;
      this.dialogFormVisible = true;
      this.title = "新增竞价规则";
      this.$nextTick(() => {
        for (var k in this.addform) {
          this.addform[k] = "";
        }
        this.$refs["addform"].resetFields();
      });
    },
    handleClick(row) {
      this.flag = 2;
      this.dialogViewVisible = true;
      this.detailObj = row;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryBiddingRulesPage();
    },
    disableItem(row) {
      this.$confirm("确定禁用该规则?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            ruleId: row.ruleId,
            status: 2
          };
          fetchPost("/saas/priceVieRules/updatePriceVieRules", data).then(
            res => {
              if (res) {
                this.queryBiddingRulesPage();
                this.$message({
                  type: "success",
                  message: "禁用成功!"
                });
              }
            }
          );
        })
        .catch(() => {});
    },
    enableItem(row) {
      this.$confirm("确定启用该规则?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            ruleId: row.ruleId,
            status: 1
          };
          fetchPost("/saas/priceVieRules/updatePriceVieRules", data).then(
            res => {
              if (res) {
                this.queryBiddingRulesPage();
                this.$message({
                  type: "success",
                  message: "启用成功!"
                });
              }
            }
          );
        })
        .catch(() => {});
    },
    deleteItem(row) {
      this.$confirm("确定删除该规则?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            ruleId: row.ruleId
          };
          fetchPost("/saas/priceVieRules/deletePriceVieRules", data).then(
            res => {
              if (res) {
                this.queryBiddingRulesPage();
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }
            }
          );
        })
        .catch(() => {});
    },
    insertBiddingRules() {
      var data = {
        ruleName: this.addform.name,
        effectStartTm: this.addform.startTm,
        effectEndTm: this.addform.endTm,
        expPriceMultiples: this.addform.minmultiple,
        expPriceMultiplesEnd: this.addform.maxmultiple,
        minPrice: this.addform.minprice,
        maxPrice: this.addform.maxprice,
        autoEvalBidding: 1
      };
      fetchPost("/saas/priceVieRules/insertPriceVieRules", data).then(res => {
        if (res) {
          this.dialogFormVisible = false;
          this.queryBiddingRulesPage();
          this.$message({
            type: "success",
            message: "新增成功!"
          });
        }
      });
    },
    modifyItem(row) {
      this.flag = 3;
      this.dialogFormVisible = true;
      this.title = "修改竞价规则";
      this.$nextTick(() => {
        this.$refs["addform"].resetFields();
        this.addform.name = row.ruleName;
        this.addform.startTm = row.effectStartTm;
        this.addform.endTm = row.effectEndTm;
        this.addform.minmultiple = row.expPriceMultiples;
        this.addform.maxmultiple = row.expPriceMultiplesEnd;
        this.addform.minprice = row.minPrice;
        this.addform.maxprice = row.maxPrice;
        this.addform.ruleId = row.ruleId;
        this.addform.status = row.status;
        this.addform.autoEvalBidding = row.autoEvalBidding;
      });
    },
    updateBiddingRules() {
      var data = {
        ruleId: this.addform.ruleId,
        ruleName: this.addform.name,
        status: this.addform.status,
        effectStartTm: this.addform.startTm,
        effectEndTm: this.addform.endTm,
        expPriceMultiples: this.addform.minmultiple,
        expPriceMultiplesEnd: this.addform.maxmultiple,
        minPrice: this.addform.minprice,
        maxPrice: this.addform.maxprice,
        autoEvalBidding: this.addform.autoEvalBidding
      };
      fetchPost("/saas/priceVieRules/updatePriceVieRules", data).then(res => {
        if (res) {
          this.dialogFormVisible = false;
          this.queryBiddingRulesPage();
          this.$message({
            type: "success",
            message: "修改成功!"
          });
        }
      });
    },
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //alert('submit!');
          if (this.flag == 1) {
            this.insertBiddingRules();
          } else if (this.flag == 3) {
            this.updateBiddingRules();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
function formatDate(date, format) {
  if (!date) return null;
  if (!(date instanceof Date)) return null;
  if (!format) format = this.FORMAT_DATE_TIME;
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  if (month < 10) month = "0" + month;
  var day = date.getDate();
  if (day < 10) day = "0" + day;
  var hours = date.getHours();
  if (hours < 10) hours = "0" + hours;
  var minutes = date.getMinutes();
  if (minutes < 10) minutes = "0" + minutes;
  var seconds = date.getSeconds();
  if (seconds < 10) seconds = "0" + seconds;
  return format
    .replace("yyyy", year)
    .replace("MM", month)
    .replace("dd", day)
    .replace("HH", hours)
    .replace("mm", minutes)
    .replace("ss", seconds);
}
</script>
<style>
#app .el-form-item__content {
  width: auto !important;
}
</style>
<style lang="less" scoped>
/deep/.el-form--inline .el-form-item {
  margin-right: 15px !important;
}
/deep/.el-radio__input{
  margin-right: 6px !important; 
}
.content_box {
  padding: 20px 25px !important;
  background: #fff;
  .table_box {
    margin-top: 20px !important;
    /deep/.el-table .cell {
      padding: 0 10px !important;
    }
  }
}
.clearfix:after {
    content: "";
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
  }
  
  .clearfix:after {
    *zoom: 1;
    /*针对IE6/IE7*/
  }
</style>